import { motion } from 'motion/react';

export const WinnerTitle = ({ className, startDelay }) => {
  const letters = 'ПОБЕДИТЕЛЬ!'.split('').reverse();

  return (
    <div className={className} dir="rtl">
      {letters &&
        letters.map((l, idx, arr) => {
          let initialIdx = 3;
          let oneLetterWidth = 6;
          let initialX = `${(idx - initialIdx) * oneLetterWidth}rem`;

          return (
            <motion.div
              style={{ position: 'relative', zIndex: idx * -1 }}
              key={l + idx}
              initial={{ scale: 0, x: initialX }}
              animate={{ scale: 1, x: 0 }}
              transition={{ duration: 0.2, delay: idx * 0.05 + startDelay }}
            >
              {l}
            </motion.div>
          );
        })}
    </div>
  );
};
